<script setup lang="ts">
    import EchoButton from '../components/EchoButton.vue';
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import UserDetails from '../components/users/UserDetails.vue';
    import { __ } from '../stores/expressions';
    import { useRouter } from 'vue-router';
    import { ref, Ref } from 'vue';
    import { useSuccessDialog } from '../stores/success-dialog';
    import { createUser } from '../services/api/user/userApi';
    import { CheckIcon, XIcon } from '@lucide/vue';

    const router = useRouter();
    const successDialogStore = useSuccessDialog();

    type UserDetailsRef = {
        submit: () => void;
        canSubmit: boolean;
    };

    const userDetailsRef: Ref<UserDetailsRef | null> = ref(null);

    const saveUser = async (formData: {
        firstName: string;
        lastName: string;
        email: string;
        emailVerified: boolean;
        password?: string;
        setTemporaryPassword: boolean;
        roleId: string;
    }) => {
        await createUser(formData);

        await successDialogStore.openDialog({
            message: __('save-user-success-message', {
                name: `${formData.firstName} ${formData.lastName}`,
            }),
        });
        router.push('/settings/manage-users');
    };

    const submitForm = () => {
        userDetailsRef.value?.submit();
    };

    const cancel = () => {
        router.push('/settings/manage-users');
    };
</script>
<template>
    <SettingsPageLayout>
        <template #header>
            <h1 class="heading-lg-light">{{ __('manage-users-add-new-user') }}</h1>
            <p class="text-body">
                {{ __('add-new-user-subtitle') }}
            </p>
        </template>
        <template #topbar>
            <EchoButton
                variant="primary"
                :disabled="!userDetailsRef?.canSubmit"
                @click="submitForm"
            >
                {{ __('save') }}
                <template #icon-right><CheckIcon /></template>
            </EchoButton>
            <EchoButton variant="secondary" @click="cancel">
                {{ __('cancel') }}
                <template #icon-right><XIcon /></template>
            </EchoButton>
        </template>
        <template #content>
            <UserDetails ref="userDetailsRef" @save="saveUser" />
        </template>
    </SettingsPageLayout>
</template>
